import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SwiperModule } from 'swiper/angular';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { UnauthorizedAccessInterceptor } from './auth/interceptors/unauthorized-access.interceptor';
import { ComponentsModule } from './components/components.module';
import { MediaPlayerComponent } from './components/media-player/media-player.component';
import { LoggedModule } from './logged/logged.module';
import { AdminComponent } from './logged/pages/admin/admin.component';
import { DashboardPage } from './logged/pages/dashboard/dashboard.page';
import { DaysComponent } from './logged/pages/days/days.component';
import { MessageComponent } from './logged/pages/message/message.component';
import { MessagesComponent } from './logged/pages/messages/messages.component';
import { TrackProgressComponent } from './logged/pages/track-progress/track-progress.component';
import { WeeksPage } from './logged/pages/weeks/weeks.page';
import { WorkoutPage } from './logged/pages/workout/workout.page';
import { WorkoutsPage } from './logged/pages/workouts/workouts.page';
import { FormatWorkoutUrlPipe } from './pipes/format-workout-url/format-workout-url.pipe';
@NgModule({
  declarations: [
    AppComponent,
    WorkoutsPage,
    WeeksPage,
    WorkoutPage,
    FormatWorkoutUrlPipe,
    MediaPlayerComponent,
    DashboardPage,
    DaysComponent,
    MessagesComponent,
    MessageComponent,
    AdminComponent,
    TrackProgressComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ComponentsModule,
    AuthModule,
    LoggedModule,
    FormsModule,
    ReactiveFormsModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    SwiperModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedAccessInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
